const htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&#x27;': "'",
}

const htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

const reEscapedHtml = /&(?:amp|lt|gt|quot|#(?:x27|39));/g
const reHasEscapedHtml = RegExp(reEscapedHtml.source)
const reUnescapedHtml = /[&<>"']/g
const reHasUnescapedHtml = RegExp(reUnescapedHtml.source)

/**
 *
 * "something written like this" => "Something written like this"
 */
export const capitalize = (str?: string): string => {
  if (!str || str.length === 0) {
    return ''
  }
  const lower = str.toLowerCase()
  return lower.substring(0, 1).toUpperCase() + lower.substring(1, lower.length)
}

export const removeAccents = (str: string) =>
  str.normalize('NFD').replace(/\p{Diacritic}/gu, '')

export const unescape = (string: string) => {
  return string && reHasEscapedHtml.test(string)
    ? string.replace(reEscapedHtml, (entity) => htmlUnescapes[entity] || "'")
    : string || ''
}

export const escape = (string: string) => {
  return string && reHasUnescapedHtml.test(string)
    ? string.replace(reUnescapedHtml, (chr) => htmlEscapes[chr])
    : string || ''
}

export const getRandomCode = (size: number): string => {
  let text = ''
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < size; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

/**
 *
 * capitalize only first character
 */
export const capitalizeFirst = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1)

/**
 *
 * "THIS_KIND_OF_STRING" -> "ThisKindOfString"
 */
export const capitalizeUpperSnakeCase = (s: string) =>
  s
    .split('_')
    .map((subS) => subS.charAt(0).toUpperCase() + subS.slice(1).toLowerCase())
    .join('')

/**
 *
 * "Capitalized Phrase To Phrase" -> "Capitalized phrase to phrase"
 */
export const keepOnlyFirstCharCapitalized = (s: string) =>
  s.charAt(0) + s.slice(1).toLowerCase()

/**
 *
 * "createNewUser" -> "Create new user"
 */
export const camelCaseToPhrase = (s: string) =>
  keepOnlyFirstCharCapitalized(
    capitalizeFirst(s)
      .replace(/([A-Z])/g, ' $1')
      .trim(),
  )
